import { useTranslation } from "react-i18next";

import LanguageSwitcher from "./LanguageSwitcher.jsx";

/**
 * Shared layout for the public auth pages (login / register / reset).
 * Includes the language switcher in the top-right so users can pick
 * their language before they even sign in.
 */
export default function AuthShell({ title, subtitle, children, footer }) {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen grid lg:grid-cols-2 relative">
      <div className="absolute top-4 right-4 z-10">
        <LanguageSwitcher />
      </div>

      <aside className="hidden lg:flex flex-col justify-between bg-brand-100 p-12">
        <div>
          <span className="mono text-brand-700 text-xs tracking-widest">
            SEOGEEKS
          </span>
          <h1 className="mt-3 text-4xl font-semibold text-slate-900 leading-tight">
            {t("auth.brandPanelTitle")}
          </h1>
          <p className="mt-4 max-w-md text-slate-700">
            {t("auth.brandPanelBody")}
          </p>
        </div>
        <ul className="text-sm text-slate-700 space-y-2">
          <li>– {t("landing.feature1Title")}</li>
          <li>– {t("landing.feature2Title")}</li>
          <li>– {t("landing.feature3Title")}</li>
          <li>– {t("landing.feature4Title")}</li>
        </ul>
      </aside>

      <main className="flex flex-col items-center justify-center p-8 bg-white">
        <div className="w-full max-w-sm">
          <h2 className="text-2xl font-semibold text-slate-900">{title}</h2>
          {subtitle && <p className="mt-1 text-sm text-slate-600">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-sm text-slate-600">{footer}</div>}
        </div>
      </main>
    </div>
  );
}
